import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import RecurringTransferPageUI from './RecurringTransferPageUI.js'

class RecurringTransferPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      scheduledTaskList: null,
      createMode: false,
      updateMode: false,
      selectedScheduledTask: null,
      deleteMode: false,
      standingInstructionLogList: null,
      details: false,
      yearMonthList: [],
      selectedYearMonth: null
    }
  }

  render() {
    return (
      <RecurringTransferPageUI
        context={this.props.context}
        account={this.state.account}
        onRefreshClick={this.onRefreshClick}
        scheduledTaskList={this.state.scheduledTaskList}
        //
        createMode={this.state.createMode}
        onScheduledTaskCreateClick={() => { this.setState({ createMode: true }) }}
        onScheduledTaskCreateCancel={() => { this.setState({ createMode: false }) }}
        //
        updateMode={this.state.updateMode}
        onScheduledTaskUpdateClick={this.onScheduledTaskUpdateClick}
        onScheduledTaskUpdateCancel={() => { this.setState({ updateMode: false }) }}
        selectedScheduledTask={this.state.selectedScheduledTask}
        //
        deleteMode={this.state.deleteMode}
        onScheduledTaskDeleteClick={this.onScheduledTaskDeleteClick}
        //
        standingInstructionLogList={this.state.standingInstructionLogList}
        filteredStandingInstructionLogList={this.getFilteredStandingInstructionLogList()}
        details={this.state.details}
        onDetailsClick={() => {this.setState({details: !this.state.details})}}
        yearMonthList={this.state.yearMonthList}
        selectedYearMonth={this.state.selectedYearMonth}
        onYearMonthChange={this.onYearMonthChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getScheduledTasks(context)
    this.getStandingInstructionLogs(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }
  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getScheduledTasks(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/scheduledTasks`,
      cacheKey: CacheKeys.ScheduledTasks(this.props.match.params.accountId),
      callback: this.getScheduledTasksCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getScheduledTasksCallback = (response) => {
    this.setState({
      scheduledTaskList: response.scheduledTaskList
    })
  }

  getStandingInstructionLogs(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/eventLogs/standingInstructions`,
      cacheKey: CacheKeys.StandingInstructionLogs(this.props.match.params.accountId),
      callback: this.getStandingInstructionLogsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getStandingInstructionLogsCallback = (response) => {
    let eventLogList = response.eventLogList || []
    let yearMonthList = this.extractYearMonthList(eventLogList)
    let selectedYearMonth = yearMonthList.length > 0 ? yearMonthList[0].value : null
    this.setState({
      standingInstructionLogList: eventLogList,
      yearMonthList: yearMonthList,
      selectedYearMonth: selectedYearMonth
    })
  }

  extractYearMonthList = (eventLogList) => {
    if (!eventLogList || eventLogList.length === 0) {
      return []
    }
    let yearMonthList = eventLogList
      .map(eventLogMonth => eventLogMonth.yearMonth)
      .filter((yearMonth, index, arr) => yearMonth && arr.indexOf(yearMonth) === index)
      .map(yearMonth => ({
        value: yearMonth,
        label: yearMonth
      }))
    return yearMonthList
  }

  getFilteredStandingInstructionLogList = () => {
    if (!this.state.standingInstructionLogList || !this.state.selectedYearMonth) {
      return null
    }
    return this.state.standingInstructionLogList.filter(
      eventLogMonth => eventLogMonth.yearMonth === this.state.selectedYearMonth
    )
  }

  onYearMonthChange = (yearMonth) => {
    this.setState({ selectedYearMonth: yearMonth })
  }

  onScheduledTaskUpdateClick = (event) => {
    let scheduledTaskId = event.currentTarget.getAttribute('data-id')
    let selectedScheduledTask = this.state.scheduledTaskList.filter(
      t => String(t.scheduledTaskId) === String(scheduledTaskId)
    )[0]
    this.setState({ updateMode: true, selectedScheduledTask: selectedScheduledTask })
  }

  onScheduledTaskDeleteClick = (event) => {
    if (this.state.deleteMode)
      return

    let scheduledTaskId = event.currentTarget.getAttribute('data-id')
    let selectedScheduledTask = this.state.scheduledTaskList.filter(
      t => String(t.scheduledTaskId) === String(scheduledTaskId)
    )[0]
    this.setState({ deleteMode: true, selectedScheduledTask })

    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/scheduledTasks/${selectedScheduledTask.scheduledTaskId}`,
      this.onScheduledTaskDeleteCallback, {}
    )
  }

  onScheduledTaskDeleteCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      errorList: errorList,
      successMsg: response.success,
      deleteMode: false,
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.onRefreshClick()
      }, 2000)
    }
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.ScheduledTasks(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.StandingInstructionLogs(this.props.match.params.accountId))
    this.setState({ 
      scheduledTaskList: null, 
      standingInstructionLogList: null,
      yearMonthList: [],
      selectedYearMonth: null
    },
      () => {
        this.getScheduledTasks(context)
        this.getStandingInstructionLogs(context)
      }
    )
  }
}

export default withRouter(RecurringTransferPageSF)
